import { createContext, useContext } from 'react';
// NOTE: The default value for react context is not used in this app.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DashboardContext = createContext(undefined);
export const useDashboard = () => useContext(DashboardContext);
export const useUploadQueue = () => (useDashboard().uploadQueueController.useUploadQueue());
